import { useEffect, useState } from "react";
import Api from "../openapi";
import { AdminPlanDetailResponse, PlanBriefResponse } from "../openapi/client";
import { PlanOptionBriefResponse } from "../openapi/client";

export function usePlans() {
  const [planList, setPlanList] = useState<PlanBriefResponse[]>([]);

  useEffect(() => {
    const getPlans = async () => {
      try {
        const res = await Api.Plan.listBriefPlans();
        setPlanList(res.data);
      } catch (error) {}
    };
    getPlans();
  }, []);
  return planList;
}

export function usePlanOptions(planId: string) {
  const [planOptionList, setPlanOptionList] = useState<PlanOptionBriefResponse[]>([]);

  useEffect(() => {
    const getPlanOptions = async () => {
      try {
        const res = await Api.Plan.listBriefPlanOptions(planId);
        setPlanOptionList(res.data);
      } catch (error) {}
    };
    if (planId) {
      getPlanOptions();
    }
  }, [planId]);
  return planOptionList;
}

export function usePlan(planId: string) {
  const [planDetail, setPlanDetail] = useState<AdminPlanDetailResponse>();

  useEffect(() => {
    const getPlan = async () => {
      try {
        const res = await Api.Plan.getPlanById(planId);
        setPlanDetail(res.data);
      } catch (error) {}
    };
    if (planId) {
      getPlan();
    }
  }, [planId]);
  return planDetail;
}

export default { usePlans, usePlanOptions, usePlan };
